import angular from 'angular';
import template from './template.html';
import './style.scss';
import { RECRUITER_WORKFLOW_STATUS } from '../../../recruiter/constants/recruiter-workflow';


const dataTestIdMap = {
    [RECRUITER_WORKFLOW_STATUS.PROSPECT]: 'cm-prospects-item',

    [RECRUITER_WORKFLOW_STATUS.CLAIMED]: 'cm-claimed-item',

    [RECRUITER_WORKFLOW_STATUS.ENGAGED]: 'cm-engaged-item',

    [RECRUITER_WORKFLOW_STATUS.READY]: 'cm-ready-item',

    [RECRUITER_WORKFLOW_STATUS.SENT]: 'cm-sent-item',

    [RECRUITER_WORKFLOW_STATUS.HIRED]: 'cm-hired-item',

    [RECRUITER_WORKFLOW_STATUS.REJECTED]: 'cm-not-a-fit-item',
};

export class CandidateWorkflowStep {
    candidateWorkflowStepHref = '';

    /* @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onChanges() {
        this.candidateWorkflowStepHref = this.getCandidateWorkflowHref(this.workflowStep);
    }

    getCandidateWorkflowHref(workflowStep) {
        return this.$state.href(this.pathName, {
            workflowStep,
            talentID: null,
            currCandidatePage: 1,
            feedbackFilterMode: null,
        });
    }

    getDataTestId(workflowStep) {
        return dataTestIdMap[workflowStep] || '';
    }
}

export const CandidateWorkflowItemChainedConfiguration = {
    template,
    bindings: {
        workflowStep: '<',
        count: '<',
        pathName: '<',
        labelKey: '<',
        workflowData: '<',
        isSelected: '<',
        testId: '<',
    },
    controller: CandidateWorkflowStep,
    controllerAs: 'candidateWorkflowStepCtrl',
};

export const CandidateWorkflowItemConfiguration = {
    template,
    bindings: {
        workflowStep: '<',
        count: '<',
        pathName: '<',
        labelKey: '<',
        workflowData: '<',
        isSelected: '<',
        testId: '<',
    },
    controller: CandidateWorkflowStep,
    controllerAs: 'candidateWorkflowStepCtrl',
};

angular
    .module('TALENYA-FE')
    .component('candidateWorkflowStepChained', CandidateWorkflowItemChainedConfiguration)
    .component('candidateWorkflowStep', CandidateWorkflowItemConfiguration);
